var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},_vm._l((_vm.paperList),function(item){return _c('div',{key:item.id,staticClass:"urlModel"},[_c('span',{staticStyle:{"color":"#2caf7a","cursor":"pointer"},on:{"click":function($event){return _vm.goToUrl(item.id)}}},[_vm._v("\n      "+_vm._s(item.title)+"\n    ")])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41dc3506","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PersonalCenters/components/ExamPaperList.vue
// module id = null
// module chunks = 